export default __webpack_public_path__ + "static/media/TransparentClose.af9bb104.svg";